import { WITNESS_COPY } from "./witness.constants.ts";
import type { WitnessLineView } from "./witness.model.ts";

/**
 * The ruled list of witnessed states.
 *
 * Drawn by the Record tab on a work and by the proof page for a bundle, so
 * that one leaf is described one way wherever a reader meets it. Both callers
 * hand it lines `toWitnessPanel` already decided; it prints and nothing else.
 */
export function WitnessLines({ lines }: { lines: readonly WitnessLineView[] }) {
  return (
    <ol className="witness__list">
      {lines.map((line) => (
        <li key={line.id} className={`witness__line witness__line--${line.anchor.kind}`}>
          <p className="witness__what">
            <span className="witness__subject">{line.subject}</span>
            <span className="witness__state">{line.state}</span>
          </p>
          <p className="witness__when">
            {WITNESS_COPY.witnessedAt} {line.witnessedAt}
          </p>
          <p className="witness__anchor">{line.anchor.label}</p>
          <p className={`witness__check witness__check--${line.check.kind}`}>
            {line.check.label}
            {line.fieldsChecked > 0 && (
              <span className="witness__fields">
                {" "}
                · {line.fieldsChecked}{" "}
                {line.fieldsChecked === 1 ? WITNESS_COPY.fieldOpened : WITNESS_COPY.fieldsOpened}
              </span>
            )}
          </p>
          {line.check.detail && <p className="witness__detail">{line.check.detail}</p>}
        </li>
      ))}
    </ol>
  );
}
